import { render, staticRenderFns } from "./BankAccountInformation.vue?vue&type=template&id=1c53e25e&scoped=true"
import script from "./BankAccountInformation.vue?vue&type=script&lang=js"
export * from "./BankAccountInformation.vue?vue&type=script&lang=js"
import style0 from "./BankAccountInformation.vue?vue&type=style&index=0&id=1c53e25e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53e25e",
  null
  
)

export default component.exports